import { selectize } from '@selectize/selectize'
import { Fancybox } from '@fancyapps/ui'
import { searchSpinner, updateQueryStringParameter, getRexDocuments } from './custom-functions.js'

// selectize all select elements with default settings.
window.selectizeTheWorld = () => {
	// Exclude .gfield_select and .epl-sort-listings
	jQuery('select:not(.gfield_select):not(.epl-sort-listings):not(.suburb-search)').selectize({
		plugins: ['remove_button', 'restore_on_backspace', 'clear_button', 'auto_position'],
		delimiter: ',',
		persist: false,
		create: function (input) {
			return {
				value: input, text: input,
			}
		},
	})
	jQuery('select.epl-sort-listings').selectize({
		plugins: [],
		delimiter: ',',
		persist: false,
		create: function (input) {
			return {
				value: input, text: input,
			}
		},
	})
	jQuery('select.suburb-search').selectize({
		plugins: ['remove_button', 'clear_button'],
		delimiter: ',',
		persist: false,
		maxItems: 1,
		create: function (input) {
			return {
				value: input, text: input,
			}
		},
	})
}

// Update the sort order when clicked.
window.changePropertySortOrder = () => {

	const sortOrder = document.getElementById('epl-sort-listings-');

	if (sortOrder) {
		jQuery('#epl-sort-listings-').selectize({
			onChange: function (value, isOnInitialize) {
				if (value !== '') {
					let url = window.location.href;
					let newUrl = updateQueryStringParameter(url, 'sortby', value);
					window.location.replace(newUrl);
				}
			}
		});
	}
}

/**
 * Once the page loads, do our stuff!
 */
document.addEventListener('DOMContentLoaded', function () {

	// Fix for the sort order tool from EPL on property archive pages.
	changePropertySortOrder();

	// Check for submit buttons and add spinner.
	searchSpinner();

	// Enables Selectize on all select elements.
	selectizeTheWorld();

	// Get Fancybox going.
	Fancybox.bind('[data-fancybox]', {})

	// Enable Tooltips for BootStrap 5.3.
	const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
	tooltipTriggerList.forEach(tooltipTriggerEl => new understrap.Tooltip(tooltipTriggerEl))

	// Get the contract link element, and if it exists, load the data when the dropdown is clicked.
	const documentLinks = document.getElementById('contract-links');
	if (documentLinks) {
		documentLinks.addEventListener('show.bs.dropdown', event => {
			getRexDocuments(documentLinks.dataset.id)
		});
	}
});

// Google Maps Places Autocomplete for Instant Property Appraisal
document.addEventListener('DOMContentLoaded', function () {
	var appraisalInput = document.querySelector('#gform_fields_2 #input_2_1');
	if (appraisalInput) {
		// Load Google Maps script dynamically if not already loaded
		if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
			var script = document.createElement('script');
			script.type = 'text/javascript';
			script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBC4crMGoeZPVGN_UGmjj18MMLykQvHCIk&libraries=places';
			script.onload = function () {
				initializeAppraisalAutocomplete();
			};
			document.head.appendChild(script);
		} else {
			initializeAppraisalAutocomplete();
		}
	}
});

function initializeAppraisalAutocomplete() {
	var input = document.querySelector('#gform_fields_2 #input_2_1');
	if (input && typeof google !== 'undefined' && google.maps && google.maps.places) {
		new google.maps.places.Autocomplete(input, {
			componentRestrictions: { country: 'au' },
		});
	}
}

document.addEventListener('DOMContentLoaded', function () {
	// For each video modal trigger
	document.querySelectorAll('[id^="toggle-video-"]').forEach(function (btn) {
		var modalId = btn.getAttribute('data-bs-target');
		var videoSrc = btn.getAttribute('data-src');
		if (!modalId || !videoSrc) return;
		var modal = document.querySelector(modalId);
		if (!modal) return;

		// Helper to force autoplay=1 in the src, replacing any existing autoplay param
		function forceAutoplaySrc(src) {
			if (!src) return src;
			// Remove any existing autoplay param
			src = src.replace(/[?&]autoplay=\d+/g, '');
			// Remove trailing ? or & if left
			src = src.replace(/[?&]$/, '');
			var hasQuery = src.indexOf('?') !== -1;
			var sep = hasQuery ? '&' : '?';
			return src + sep + 'autoplay=1';
		}

		// Play video on modal show
		modal.addEventListener('show.bs.modal', function () {
			var iframe = modal.querySelector('iframe');
			var video = modal.querySelector('video');
			if (iframe) {
				// iframe (YouTube/Vimeo)
				iframe.src = forceAutoplaySrc(videoSrc);
			}
			if (video) {
				// video tag (local file)
				video.currentTime = 0;
				video.play();
			}
		});
		// Stop video on modal hide
		modal.addEventListener('hidden.bs.modal', function () {
			var iframe = modal.querySelector('iframe');
			var video = modal.querySelector('video');
			if (iframe) {
				iframe.src = '';
			}
			if (video) {
				video.pause();
				video.currentTime = 0;
			}
		});
	});
});